document.addEventListener("DOMContentLoaded", () => {
	const burgerWrapper = document.querySelector(".burger-menu");
	const burgerClose   = document.querySelector(".burger-menu__close");
	const burgerLines   = document.querySelector(".burger-js");
    const header        = document.getElementsByClassName("header")[0];

    if (header) {
		window.addEventListener("scroll", function () {
			if (window.scrollY > 100) {
				header.classList.add("scrolled");
				body.classList.add("scrolled");
			} else {
				header.classList.remove("scrolled");
				body.classList.remove("scrolled");
			}
		});
	}

    if (burgerLines) {
		burgerLines.addEventListener("click", function () {
			if (burgerWrapper) {
				burgerWrapper.classList.add("active");
			}
		});
	}

	if (burgerClose) {
		burgerClose.addEventListener("click", function () {
			if (burgerWrapper) {
				burgerWrapper.classList.remove("active");
			}
		});
	}

	if (burgerWrapper) {
		burgerWrapper.addEventListener("click", function (e) {
			if (e.target === burgerWrapper) {
				burgerWrapper.classList.remove("active");
			}
		});
	}
});
